import { SortOrder } from '../enums';

/**
 * Utility to sort an array of objects based on a property key and SortOrder (asc/desc).
 * Handles numbers, strings, dates, booleans, and null/undefined values safely.
 */
export function sortData<T>(data: T[], orderBy: string, order: SortOrder): T[] {
  if (!data || data.length === 0 || !orderBy) return data || [];

  return [...data].sort((a: any, b: any) => {
    let valA = a[orderBy];
    let valB = b[orderBy];

    if (valA == null) valA = '';
    if (valB == null) valB = '';

    // Booleans
    if (typeof valA === 'boolean' && typeof valB === 'boolean') {
      valA = valA ? 1 : 0;
      valB = valB ? 1 : 0;
    }

    // Numbers
    if (typeof valA === 'number' && typeof valB === 'number') {
      return order === SortOrder.asc ? valA - valB : valB - valA;
    }

    // Dates / ISO strings
    if (typeof valA === 'string' && typeof valB === 'string') {
      const isDateA = !isNaN(Date.parse(valA)) && (valA.includes('-') || valA.includes('/'));
      const isDateB = !isNaN(Date.parse(valB)) && (valB.includes('-') || valB.includes('/'));
      if (isDateA && isDateB && valA.length >= 10 && valB.length >= 10) {
        const timeA = new Date(valA).getTime();
        const timeB = new Date(valB).getTime();
        if (!isNaN(timeA) && !isNaN(timeB)) {
          return order === SortOrder.asc ? timeA - timeB : timeB - timeA;
        }
      }
      valA = valA.toLowerCase();
      valB = valB.toLowerCase();
    }

    if (valA < valB) return order === SortOrder.asc ? -1 : 1;
    if (valA > valB) return order === SortOrder.asc ? 1 : -1;
    return 0;
  });
}
